(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleDeleteController',VentadetalleDeleteController);

    VentadetalleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventadetalle'];

    function VentadetalleDeleteController($uibModalInstance, entity, Ventadetalle) {
        var vm = this;

        vm.ventadetalle = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventadetalle.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
